import { Box, Grid, Typography } from "@mui/material";
import { getLayoutText } from "../../../components/layout/getLayoutText";
import { getLayoutView } from "../../../components/layout/getLayoutView";
const Problems = () => {
  return (
    <Box sx={{ backgroundColor: "white", backgroundSize: "40%" }}>
      <Grid
        container
        rowSpacing={9}
        columnSpacing={{ xs: 0, sm: 3, lg: 9 }}
        sx={{ pb: 9, px: `10%`, color: (theme) => theme.palette.grey[700] }}
      >
        {[
          {
            n: "73%",
            t: `Of African-Americans, 13 and older, report playing video games`,
            s: `source: Nielsen Report`,
          },
          {
            n: "64%",
            t: `Of minority characters are more likely to be portrayed as aggressive or committing illicit violence in game related content`,
            s: `source: Burgess et al`,
          },
          {
            n: `1%`,
            t: `Of game developers identify as African-American`,
            s: `source: IGDA Developer Satisfaction Survey`,
          },
        ].map((s, i) => (
          <Grid
            data-aos="zoom-in"
            data-aos-offset={`${100 + i * 100}`}
            key={`${s.n}:problem${i}`}
            item
            xs={12}
            sm={6}
            md={4}
            sx={{ display: `flex`, flexDirection: "column" }}
          >
            <Typography
              sx={{ mb: 1 }}
              variant="h1"
              color="primary.main"
              fontFamily="Lato-Regular"
            >
              {s.n}
            </Typography>
            <Typography variant="subtitle1" sx={{ fontSize: `14px` }}>
              {s.t}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                alignItems: `flex-end`,
                height: `100%`,
                display: `flex`,
                fontSize: `10px`,
                color: (theme) => theme.palette.grey[400],
              }}
            >
              {s.s}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <Grid
        container
        sx={{
          backgroundImage: `linear-gradient(0.35turn, #e6b40070 100%, transparent),url(${"https://website-img.polycaik.com/w/asset/429df643e2b040a6943af877c5f9dc7b.jpg"})`,
          backgroundPosition: { xs: `right center`, md: `right center` },
          backgroundRepeat: `no-repeat`,
          backgroundSize: `cover`,
          justifyContent: `flex-start`,
        }}
      >
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            backgroundColor: (theme) => `${theme.palette.grey[900]}cc`,
          }}
        >
          <Box
            // data-aos="fade-right"
            // data-aos-offset="300"
            sx={{ py: 9, px: `10%` }}
          >
            {getLayoutView(
              <>
                AN{" "}
                <span style={{ fontFamily: "Lato-Bold" }}>ISSUE</span>{" "}
                OVERLOOKED
              </>,
              [
                getLayoutText(
                  <>
                    The video game industry is a billion-dollar market with over
                    2.9 billion players yet it suffers from the same problems as
                    mainstream media outlets — a lack of diversity in the
                    content served to the public. As a result, you get the same
                    old narratives recycled and rebranded. The lack of support,
                    guidance, and funding keeps the stories of those who would
                    bring new perspectives and ideas from reaching audiences
                    abroad.
                  </>,
                  {
                    fontSize: "16px",
                    fontFamily: "Lato-Bold",
                    lineHeight: 2.25,
                  }
                ),
              ],
              [12],
              {
                p: 0,
                backgroundColor: `transparent`,
                "& .MuiTypography-root:not(.MuiTypography-caption)": {
                  color: `white`,
                },
              }
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default Problems;
